import { HorizontalAlignment, VerticalAlignment } from 'flux-core';

export const ALIGNMENT_OPTIONS = [
    {
        id: 'h-left',
        isVertical: false,
        alignment: HorizontalAlignment.Left,
        label: 'LABELS.ALIGNMENT.ALIGN_LEFT',
        icon: 'align-left',
    },
    {
        id: 'h-center',
        isVertical: false,
        alignment: HorizontalAlignment.Center,
        label: 'LABELS.ALIGNMENT.ALIGN_HORIZONTAL_CENTER',
        icon: 'align-v-center',
    },
    {
        id: 'h-right',
        isVertical: false,
        alignment: HorizontalAlignment.Right,
        label: 'LABELS.ALIGNMENT.ALIGN_RIGHT',
        icon: 'align-right',
    },
    {
        id: 'v-top',
        isVertical: true,
        alignment: VerticalAlignment.Top,
        label: 'LABELS.ALIGNMENT.ALIGN_TOP',
        icon: 'align-top',
    },
    {
        id: 'v-center',
        isVertical: true,
        alignment: VerticalAlignment.Center,
        label: 'LABELS.ALIGNMENT.ALIGN_VERTICAL_CENTER',
        icon: 'align-h-center',
    },
    {
        id: 'v-bottom',
        isVertical: true,
        alignment: VerticalAlignment.Bottom,
        label: 'LABELS.ALIGNMENT.ALIGN_BOTTOM',
        icon: 'align-bottom',
    },
    {
        id: 'space-horizontally',
        isVertical: false,
        alignment: VerticalAlignment.Center,
        label: 'LABELS.ALIGNMENT.DISTRIBUTE_HORIZONTALLY',
        icon: 'distribute-horizontally',
        isDistribution: true,
    },
    {
        id: 'space-vertically',
        isVertical: true,
        alignment: VerticalAlignment.Bottom,
        label: 'LABELS.ALIGNMENT.DISTRIBUTE_VERTICALLY',
        icon: 'distribute-vertically',
        isDistribution: true,
    },
];


export const LAYOUTING_DATA = {
    'elk-box': {
      id: 'elk-box',
      layoutingData: {
        source: 'elk',
        algorithm: 'box',
        padding: [ 10, 10, 10, 10 ],
        spacing: [ 10, 10, 10, 10 ],
        options: {
          'org.eclipse.elk.algorithm': 'box',
        },
        aspectRatio: 'dynamic',
      },
      label: 'LABELS.LAYOUT.GRID',
      icon: 'layout-grid',
    },
    'native-list': {
      id: 'native-list',
      layoutingData: {
        source: 'native',
        algorithm: 'simpleVerticalList',
        padding: [ 10, 10, 10, 10 ],
        spacing: [ 10, 10, 10, 10 ],
        options: {
          nodeBehavior: 'fill',
        },
      },
      label: 'LABELS.LAYOUT.LIST',
      icon: 'layout-list',
    },
    'd3-tree-down-compact': {
      id: 'd3-tree-down-compact',
      layoutingData: {
        source: 'd3',
        algorithm: 'treeDownComapct',
        padding: [ 50, 50, 50, 50 ],
        options: {
            childrenMargin: 100,
            compactMarginBetween: 80, // betweeen rows
            compactMarginPair: 100, // between cols
            neighbourMargin: 120,
            siblingsMargin: 120,
        },
      },
      label: 'LABELS.LAYOUT.TREE_DOWN_COMPACT',
      icon: 'layout-tree-down-compact',
    },
    'mindmap-standard': {
        id: 'mindmap-standard',
        layoutingData: {
          source: 'native',
          algorithm: 'mindmapStandard',
          options: {},
        },
        label: 'LABELS.LAYOUT.MINDMAP',
        icon: 'layout-mindmap-standard',
    },
    'elk-rectpacking': {
      id: 'elk-rectpacking',
      layoutingData: {
        source: 'elk',
        algorithm: 'rectpacking',
        padding: [ 10, 10, 10, 10 ],
        spacing: [ 10, 10, 10, 10 ],
        options: {
          'org.eclipse.elk.algorithm': 'rectpacking',
        },
        aspectRatio: 'dynamic',
      },
      label: 'LABELS.LAYOUT.PACK',
      icon: 'layout-pack',
    },
    'elk-mrtree-down': {
      id: 'elk-mrtree-down',
      layoutingData: {
        source: 'elk',
        algorithm: 'mrtree-down',
        options: {
          'org.eclipse.elk.algorithm': 'mrtree',
          'org.eclipse.elk.direction': 'DOWN',
          'org.eclipse.elk.spacing.nodeNode': '80',
        },
      },
      isVertical: true,
      alignment: VerticalAlignment.Top,
      label: 'LABELS.LAYOUT.TREE_DOWN',
      icon: 'layout-tree-down',
      type: 'tree',
    },
    'elk-mrtree-left': {
      id: 'elk-mrtree-left',
      layoutingData: {
        source: 'elk',
        algorithm: 'mrtree-left',
        options: {
          'org.eclipse.elk.algorithm': 'mrtree',
          'org.eclipse.elk.direction': 'LEFT',
          'org.eclipse.elk.spacing.nodeNode': '80',
        },
      },
      isVertical: true,
      alignment: VerticalAlignment.Top,
      label: 'LABELS.LAYOUT.TREE_LEFT',
      icon: 'layout-tree-left',
      type: 'tree',
    },
    'elk-mrtree-up': {
      id: 'elk-mrtree-up',
      layoutingData: {
        source: 'elk',
        algorithm: 'mrtree-up',
        options: {
          'org.eclipse.elk.algorithm': 'mrtree',
          'org.eclipse.elk.direction': 'UP',
          'org.eclipse.elk.spacing.nodeNode': '100',
        },
      },
      isVertical: true,
      alignment: VerticalAlignment.Top,
      label: 'LABELS.LAYOUT.TREE_UP',
      icon: 'layout-tree-up',
      type: 'tree',
    },
    'elk-mrtree-right': {
      id: 'elk-mrtree-right',
      layoutingData: {
        source: 'elk',
        algorithm: 'mrtree-right',
        options: {
          'org.eclipse.elk.algorithm': 'mrtree',
          'org.eclipse.elk.direction': 'RIGHT',
          'org.eclipse.elk.spacing.nodeNode': '80',
        },
      },
      label: 'LABELS.LAYOUT.TREE_RIGHT',
      icon: 'layout-tree-right',
      type: 'tree',
    },
    'elk-layered-up': {
      id: 'elk-layered-up',
      layoutingData: {
        source: 'elk',
        options: {
          'org.eclipse.elk.algorithm': 'layered',
          'org.eclipse.elk.spacing.nodeNode': '80',
          'org.eclipse.elk.spacing.edgeEdge': '80',
          'org.eclipse.elk.spacing.edgeNode': '80',
          'org.eclipse.elk.direction': 'UP',
          'org.eclipse.elk.layered.spacing.nodeNodeBetweenLayers': '80',
          'org.eclipse.elk.layered.crossingMinimization.forceNodeModelOrder': false,
          'org​.eclipse​.elk​.layered​.spacing​.edgeEdgeBetweenLayers': '80',
          'org​.eclipse​.elk​.layered​.spacing​.edgeNodeBetweenLayers': '80',
          'org.eclipse.elk.layered.nodePlacement.strategy': 'LINEAR_SEGMENTS',
        //   'org.eclipse.elk.layered.nodePlacement.strategy': 'NETWORK_SIMPLEX',
        },
        aspectRatio: 'dynamic',
      },
      label: 'LABELS.LAYOUT.FLOW_UP',
      icon: 'layout-flow-up',
      type: 'tree',
    },
    'elk-layered-down':     {
        id: 'elk-layered-down',
        layoutingData: {
            source: 'elk',
            options: {
                'org.eclipse.elk.algorithm': 'layered',
                'org.eclipse.elk.spacing.nodeNode': '80',
                'org.eclipse.elk.spacing.edgeEdge': '80',
                'org.eclipse.elk.spacing.edgeNode': '80',
                'org.eclipse.elk.direction': 'DOWN',
                'org.eclipse.elk.layered.spacing.nodeNodeBetweenLayers': '80',
                'org.eclipse.elk.layered.crossingMinimization.forceNodeModelOrder':  false,
                'org​.eclipse​.elk​.layered​.spacing​.edgeEdgeBetweenLayers': '80',
                'org​.eclipse​.elk​.layered​.spacing​.edgeNodeBetweenLayers': '80',
                'org.eclipse.elk.layered.nodePlacement.strategy': 'LINEAR_SEGMENTS',
            },
            aspectRatio: 'dynamic',
        },
        label: 'LABELS.LAYOUT.FLOW_DOWN',
        icon: 'layout-flow-down',
        type: 'tree',
    },
    'elk-layered-left': {
        id: 'elk-layered-left',
        layoutingData: {
            source: 'elk',
            options: {
                'org.eclipse.elk.algorithm': 'layered',
                'org.eclipse.elk.spacing.nodeNode': '80',
                'org.eclipse.elk.spacing.edgeEdge': '80',
                'org.eclipse.elk.spacing.edgeNode': '80',
                'org.eclipse.elk.direction': 'LEFT',
                'org.eclipse.elk.layered.spacing.nodeNodeBetweenLayers': '80',
                'org.eclipse.elk.layered.crossingMinimization.forceNodeModelOrder':  false,
                'org​.eclipse​.elk​.layered​.spacing​.edgeEdgeBetweenLayers': '80',
                'org​.eclipse​.elk​.layered​.spacing​.edgeNodeBetweenLayers': '80',
                'org.eclipse.elk.layered.nodePlacement.strategy': 'LINEAR_SEGMENTS',
            },
            aspectRatio: 'dynamic',
        },
        label: 'LABELS.LAYOUT.FLOW_LEFT',
        icon: 'layout-flow-left',
        type: 'tree',
    },
    'elk-layered-right': {
        id: 'elk-layered-right',
        layoutingData: {
            source: 'elk',
            options: {
                'org.eclipse.elk.algorithm': 'layered',
                'org.eclipse.elk.spacing.nodeNode': '80',
                'org.eclipse.elk.spacing.edgeEdge': '80',
                'org.eclipse.elk.spacing.edgeNode': '80',
                'org.eclipse.elk.direction': 'RIGHT',
                'org.eclipse.elk.layered.spacing.nodeNodeBetweenLayers': '80',
                'org.eclipse.elk.layered.crossingMinimization.forceNodeModelOrder':  false,
                'org​.eclipse​.elk​.layered​.spacing​.edgeEdgeBetweenLayers': '80',
                'org​.eclipse​.elk​.layered​.spacing​.edgeNodeBetweenLayers': '80',
                'org.eclipse.elk.layered.nodePlacement.strategy': 'LINEAR_SEGMENTS',
            },
            aspectRatio: 'dynamic',
        },
        label: 'LABELS.LAYOUT.FLOW_RIGHT',
        icon: 'layout-flow-right',
        type: 'tree',
    },
};


export const VIZ_DATA = {

    // Click creately viz template in template panel
    template: {
        id: 'template',
        label: '',
        userInput: {
            description: 'LABELS.SHAPE_DATA.TEMPLATE_ACCURACY_DESCRIPTION',
            header: 'LABELS.SHAPE_DATA.TEMPLATE_HEADER_QUESTION',
            placeholder: 'LABELS.SHAPE_DATA.TEMPLATE_PLACEHOLDER_EXAMPLE',
        },
        loadingText: 'LABELS.SHAPE_DATA.GENERATING_TEMPLATE',
        templatePanel: {},
        rendering: 'template',
        requestConfig: {},
        context: [ 'template' ],
    },

    // Selection - both single and multi select
    generateSimilarItems: {
        id: 'generateSimilarItems',
        label: 'LABELS.SHAPE_DATA.GENERATE_SIMILAR_ITEMS',
        context: [ 'select-single' ],
        loadingText: 'LABELS.SHAPE_DATA.GENERATING_SIMILAR_ITEMS',
        // Create new items
        rendering: 'create',
        requestConfig: {
            count: 5,
            shapeJson: {
                shapeType: true,
                primaryText: true,
                description: true,
            },
        },
        styleRefShape: 'selected',
    },
    generateCounterPoints: {
        id: 'generateCounterPoints',
        label: 'LABELS.SHAPE_DATA.GENERATE_COUNTER_POINTS',
        context: [ 'select-single' ],
        loadingText: 'LABELS.SHAPE_DATA.GENERATING_COUNTER_POINTS',
        rendering: 'create',
        requestConfig: {
            count: 5,
            shapeJson: {
                shapeType: true,
                primaryText: true,
                description: true,
            },
        },
        styleRefShape: 'selected',
    },
    generateWithCustomPrompt: {
        id: 'generateWithCustomPrompt',
        label: 'LABELS.SHAPE_DATA.GENERATE_CUSTOM_PROMPTS',
        context: [ 'select-single' ],
        userInput: {
            description: 'LABELS.SHAPE_DATA.CUSTOM_PROMPT_DESCRIPTION',
            header: 'LABELS.SHAPE_DATA.CUSTOM_PROMPT_HEADER',
            placeholder: 'LABELS.SHAPE_DATA.CUSTOM_PROMPT_PLACEHOLDER',
        },
        loadingText: 'LABELS.SHAPE_DATA.GENERATING',
        rendering: 'create',
        requestConfig: {
            count: 5,
            shapeJson: {
                shapeType: true,
                primaryText: true,
                description: true,
            },
        },
        styleRefShape: 'selected',
    },

    //  Multi select  - group
    groupByIdentifiedThemes: {
        id: 'groupByIdentifiedThemes',
        label: 'LABELS.SHAPE_DATA.GROUP_BY_THEMES',
        loadingText: 'LABELS.SHAPE_DATA.GROUPING_BY_THEMES',
        context: [ 'select-multi' ],
        template: 'VERTICAL.GROUP',
        // Will move existing items into a dynamically generated table
        rendering: 'group',
        requestConfig: {
            shapeJson: {
                shapeType: true,
                primaryText: true,
                description: true,
                properties: true,
            },
        },
    },
    groupBySentiment: {
        id: 'groupBySentiment',
        label: 'LABELS.SHAPE_DATA.GROUP_BY_SENTIMENT',
        loadingText: 'LABELS.SHAPE_DATA.GROUPING_BY_SENTIMENT',
        context: [ 'select-multi' ],
        rendering: 'group',
        template: 'VERTICAL.GROUP',
        requestConfig: {
            shapeJson: {
                shapeType: true,
                primaryText: true,
                description: true,
                properties: true,
            },
        },
    },
    groupByListedTags: {
        id: 'groupByListedTags',
        label: 'LABELS.SHAPE_DATA.GROUP_BY_TAGS',
        loadingText: 'LABELS.SHAPE_DATA.GROUPING_BY_TAGS',
        context: [ 'select-multi' ],
        rendering: 'group',
        template: 'VERTICAL.GROUP',
        requestConfig: {
            shapeJson: {
                shapeType: true,
                primaryText: true,
                description: true,
                properties: true,
            },
        },
    },
    groupCustom: {
        id: 'groupCustom',
        label: 'LABELS.SHAPE_DATA.GROUP_CUSTOM_PROMPT',
        context: [ 'select-multi' ],
        loadingText: 'LABELS.SHAPE_DATA.GROUPING_CUSTOM_INPUT',
        userInput: {
            description: 'LABELS.SHAPE_DATA.GROUP_CUSTOM_DESCRIPTION',
            header: 'LABELS.SHAPE_DATA.GROUP_AUTO_HEADER',
            placeholder: 'LABELS.SHAPE_DATA.GROUP_CUSTOM_PLACEHOLDER',
        },
        rendering: 'group',
        requestConfig: {
            shapeJson: {
                shapeType: true,
                primaryText: true,
                description: true,
                properties: true,
            },
        },
    },

    // Multi select - transform
    generateKanbanWithActionItems: {
        id: 'generateKanbanWithActionItems',
        promptType: 'generateKanbanWithActionItems',
        loadingText: 'LABELS.SHAPE_DATA.GENERATING_KANBAN',
        label: 'LABELS.SHAPE_DATA.GENERATE_KANBAN_ITEMS',
        context: [ 'select-single', 'select-multi' ],
        rendering: 'create-group', // Populate new item in a template
        template: 'VERTICAL.KANBAN',
        requestConfig: {
            shapeJson: {
                shapeType: true,
                primaryText: true,
                description: true,
                properties: true,
            },
        },
    },
    generateFlowchartFromSelectedItems: {
        id: 'generateFlowchartFromSelectedItems',
        promptType: 'generateFlowchartFromSelectedItems',
        loadingText: 'LABELS.SHAPE_DATA.GENERATING_FLOWCHART',
        label: 'LABELS.SHAPE_DATA.GENERATE_FLOWCHART_ITEMS',
        context: [ 'select-single', 'select-multi' ],
        rendering: 'create',
        requestConfig: {
            shapeJson: {
                shapeType: true,
                primaryText: true,
                description: true,
                properties: true,
            },
        },
    },
    customTransformWithTemplate: {
        id: 'customTransformWithTemplate',
        promptType: 'customTransformWithTemplate',
        loadingText: 'LABELS.SHAPE_DATA.GENERATING_CUSTOM_TRANSFORM',
        label: 'LABELS.SHAPE_DATA.CUSTOM_TRANSFORM_TEMPLATE',
        context: [ 'select-single', 'select-multi' ],
        templatePanel: {},
        rendering: 'template',
        requestConfig: {
            shapeJson: {
                shapeType: true,
                primaryText: true,
                description: true,
                properties: true,
            },
        },
    },

    // PlusCreate
    plusCreateNextItem: {
        id: 'plusCreateNextItem',
        label: 'LABELS.SHAPE_DATA.NEXT_ITEM',
        loadingText: 'LABELS.SHAPE_DATA.GENERATING_ITEM',
        context: [ 'plus-create' ],
        rendering: 'plus-create',
        requestConfig: {
            count: 1,
            shapeJson: {
                shapeType: true,
                primaryText: true,
                description: true,
                properties: true,
                bounds: true,
            },
            connectedShapesData: true,
        },
    },
    plusCreateNextFiveItem: {
        id: 'plusCreateNextFiveItem',
        label: 'LABELS.SHAPE_DATA.NEXT_FIVE_ITEMS',
        loadingText: 'LABELS.SHAPE_DATA.GENERATING_ITEMS',
        context: [ 'plus-create' ],
        rendering: 'plus-create',
        requestConfig: {
            count: 5,
            shapeJson: {
                shapeType: true,
                primaryText: true,
                description: true,
                properties: true,
                bounds: true,
            },
            connectedShapesData: true,
        },
    },
    plusCreateCustom: {
        id: 'plusCreateCustom',
        label: 'LABELS.SHAPE_DATA.CUSTOM',
        userInput: {
            description: 'LABELS.SHAPE_DATA.PLUS_CREATE_DESCRIPTION',
            header: 'LABELS.SHAPE_DATA.PLUS_CREATE_HEADER',
            placeholder: 'LABELS.SHAPE_DATA.PLUS_CREATE_PLACEHOLDER',
        },
        loadingText: 'LABELS.SHAPE_DATA.GENERATING_ITEMS',
        context: [ 'plus-create' ],
        rendering: 'plus-create',
        requestConfig: {
            count: 5,
            shapeJson: {
                shapeType: true,
                primaryText: true,
                description: true,
                properties: true,
                bounds: true,
            },
            connectedShapesData: true,
        },
    },
};
